import SignUp from "../../Components/SignUp_Section/SignUp";

const SignUpPage = () => {
  return (
    <div>
      <SignUp />
    </div>
  );
};

export default SignUpPage;
